import { QueryClient, useQueryClient } from '@tanstack/react-query'

export type FmtCompetitionEntityIdsSortedSkeleton = string[]

type GetFmtCompetitionEntityIdsSorted = (
  queryClient: QueryClient,
) => FmtCompetitionEntityIdsSortedSkeleton

type UseFmtCompetitionEntityIdsSorted =
  () => ReturnType<GetFmtCompetitionEntityIdsSorted>

const getFmtCompetitionEntityIdsSorted: GetFmtCompetitionEntityIdsSorted = (
  queryClient,
) =>
  queryClient.getQueryData<FmtCompetitionEntityIdsSortedSkeleton>([
    'fmtCompetitionEntityIdsSortedSkeleton',
  ]) ?? []

const useFmtCompetitionEntityIdsSorted: UseFmtCompetitionEntityIdsSorted = () =>
  getFmtCompetitionEntityIdsSorted(useQueryClient())

export { getFmtCompetitionEntityIdsSorted }

export default useFmtCompetitionEntityIdsSorted
